import React, { lazy, Suspense, useEffect, useState } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MetaPixel } from './components/MetaPixel';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="2wk0bn6p7uxy5">
      <MetaPixel data-id="element-1" data-mp="2wj8ehrfz0s5r" />
      <StickyHeader data-id="element-2" data-mp="2wip7v6vrtq71" />
      <main data-id="element-3" data-mp="2wi5m1f302hnq">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="28u5x8kp911bs" />
        <Hero data-id="element-5" data-mp="28suv0pbgc1ms" />
        <SocialProofBar data-id="element-6" data-mp="28sb9yzqi8x4j" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-paper" aria-hidden="true" data-id="element-8" data-mp="23utadzydnu97" />} data-id="element-7" data-mp="23u9vyt7xrnzx">
            <DeferredLanding data-id="element-9" data-mp="3ikqyfyb7r257" />
          </Suspense>}
      </main>
    </div>;
}